import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const isAuthenticating = state => state.auth.isAuthenticating;
export const isAuthenticated = state => !!state.auth.userId;

export const getUser = state =>
  denormalize(state.auth.userId, schemas.user, state.entities);

export const getUserCustomers = state =>
  denormalize(state.auth.customerIds, [schemas.customer], state.entities);

export const getActiveCustomer = state =>
  denormalize(state.auth.activeCustomerId, schemas.customer, state.entities);

export const hasMultipleCustomers = state => state.auth.customerIds.length > 1;

export const getUserUpdatePaymentMethodToken = state => {
  const { updatePaymentMethodUrl } = getActiveCustomer(state);

  return updatePaymentMethodUrl.split('/').pop();
};

export const getUserActivePaymentMethod = state => {
  const { activePaymentMethod } = getActiveCustomer(state);

  return denormalize(
    activePaymentMethod,
    schemas.paymentMethod,
    state.entities
  );
};



// WEBPACK FOOTER //
// ./src/store/auth/selectors.js